import { useState } from 'react'
import { Box, Button, Chip, TextField, Typography } from '@mui/material'

const ParameterSection = ({
  title,
  description,
  keyLabel = 'Key',
  valueLabel = 'Value',
  parameters,
  onAdd,
  onRemove,
}) => {
  const [inputKey, setInputKey] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [keyError, setKeyError] = useState('')

  const handleAdd = () => {
    if (!inputKey.trim() || !inputValue.trim()) return

    if (Object.prototype.hasOwnProperty.call(parameters, inputKey)) {
      setKeyError('A parameter with this key already exists')
      return
    }

    onAdd(inputKey, inputValue)
    setInputKey('')
    setInputValue('')
    setKeyError('')
  }

  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>

      {description && (
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {description}
        </Typography>
      )}

      <Box
        sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', mt: 2 }}
      >
        <TextField
          label={keyLabel}
          value={inputKey}
          onChange={(e) => {
            setInputKey(e.target.value)
            if (keyError) setKeyError('')
          }}
          sx={{ flex: 1 }}
          error={!!keyError}
          helperText={keyError}
        />
        <TextField
          label={valueLabel}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          sx={{ flex: 1 }}
        />
        <Button variant="outlined" onClick={handleAdd} sx={{ height: '56px' }}>
          Add
        </Button>
      </Box>

      {Object.keys(parameters).length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {Object.entries(parameters).map(([k, v]) => (
              <Chip
                key={k}
                label={`${k}: ${v}`}
                onDelete={() => onRemove(k)}
              />
            ))}
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default ParameterSection
